<template>
  <div class="modal-wrapper">
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Permissões do Usuário
          </h4>
        </div>
        <div class="modal-body modal-body--scrollable">
          <table class="table table-striped">
            <tbody>
              <tr>
                <th>Nome</th>
                <td>{{ user.name }}</td>
              </tr>
              <tr>
                <th>E-mail</th>
                <td>{{ user.email }}</td>
              </tr>
            </tbody>
          </table>

          <h4>Permissões Atuais</h4>
          <div class="permissions-list">
            <div
              v-for="(userRole) in assignedRoles"
              :key="userRole.id"
              class="permission-card"
            >
              {{ userRole.admin_role.description }}
            </div>
            <div v-if="assignedRoles.length == 0">
              Nenhuma permissão atribuída
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminUsersService from 'services/AdminUsersService';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      assignedRoles: [],
    };
  },
  methods: {
    loadUserRoles() {
      AdminUsersService.getUserRoles(this.user.id)
        .then((result) => {
          this.assignedRoles = result;
        });
    },
  },
  mounted() {
    this.loadUserRoles();
  },
};
</script>

<style scoped>
  .permission-card {
    background-color: #e9ecef;
    border-radius: 5px;
    border: 1px solid #ced4da;
    padding: 5px 10px;
    display: block;
  }

  .permissions-list {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
  }
</style>
